<div class="tw-flex tw-flex-col tw-h-full tw-bg-teal-200 tw-bg-repeat-x tw-bg-top tw-overflow-y-auto"
  #scrollContainer>
  <div class="tw-flex-1 tw-px-6 tw-pt-15 tw-flex tw-flex-col">
    <div class="tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-3 tw-text-center">
      <p class="tw-font-lexend tw-text-300 tw-uppercase tw-font-light" i18n="@@curesVerification">Cure's Verification</p>
      <div class="tw-font-lexend tw-font-bold tw-text-800 tw-text-gray-800 title"
      i18n="@@getInSecurely">Lets get you <br/> in securely</div>
      <img class="tw-block tw-w-32"
        src="/assets/icons/secure-lock.svg"
        alt="icon" />
    </div>
  </div>
  <div class="tw-flex-none tw-rounded-tr-5 tw-rounded-tl-5 tw-px-6 tw-pt-8 tw-bg-white">
    <div class="tw-font-lexend tw-text-300 tw-text-gray-800 tw-mb-1"
      i18n="@@weHaveSentADigitCode">
      We have sent a {{otpLength}}-digit code<br>to your mobile number
    </div>
    <div id="edit-number"
      class="tw-flex tw-items-center tw-font-body tw-text-300 tw-text-gray-800 tw-mb-5"
      (click)="editNumber()">
      <span class="tw-font-bold tw-mr-[14px]">+91 {{mobileNumber}}</span>
      <div class="tw-flex tw-items-baseline">
        <span class="tw-text-teal-600 tw-text-200 tw-font-bold tw-tracking-[0.3px]"
        i18n="@@edit">Edit</span>
        <cs-icon class="tw-h-2 tw-w-2 tw-ml-2"
        [iconName]="'/rebranding/v1/arrow_forward'"></cs-icon>
      </div>
    </div>
    @if (loginWithShiprocket) {
      <div class="tw-mb-2 tw-transition-opacity tw-duration-200"
        [class.tw-opacity-40]="switchingToCureskinOtp"
        [class.tw-pointer-events-none]="switchingToCureskinOtp">
        <div class="tw-flex tw-items-center tw-gap-2">
          @for (index of shiprocketBoxes; track index) {
            <input
              #otpBox=""
              no-copy
              class="tw-text-center tw-select-none tw-h-11 tw-w-11 tw-rounded-2.5 tw-bg-gray-80 tw-border tw-border-solid tw-border-gray-300 tw-m-0 tw-p-0 tw-font-body tw-text-300 tw-text-gray-800"
              [ngClass]="{'tw-border-teal-400': shiprocketDigits[index] && !otpError, 'tw-border-orange-500': otpError}"
              [attr.id]="'otpBox' + index"
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
              maxlength="1"
              autocomplete="off"
              [disabled]="switchingToCureskinOtp"
              [autofocus]="index === 0 ? 'autofocus' : null"
              (input)="onShiprocketOtpInput(index, $event)"
              (keydown)="onShiprocketOtpKeydown(index, $event)"
              (paste)="onShiprocketOtpPaste($event)" />
          }
        </div>
      </div>
    }
    <div class="tw-flex-none tw-rounded-tr-5 tw-rounded-tl-5 tw-bg-white">
      @if (!loginWithShiprocket) {
        <div class="tw-relative tw-mb-2"
          [class.tw-animate-onboarding_page_enter]="switchedFromShiprocket">
          <div class="tw-flex tw-items-center tw-gap-2">
            @for (index of [0, 1, 2, 3]; track index) {
              <div class="tw-h-12 tw-w-12 tw-rounded-2.5 tw-bg-gray-80 tw-border tw-border-solid tw-border-gray-300"
              [ngClass]="{'tw-border-teal-400': isOtpValid && !otpError, 'tw-border-orange-500': otpError}"></div>
            }
          </div>
          <div class="tw-absolute tw-top-0 tw-w-full">
            <input no-copy
              class="tw-select-none tw-w-full tw-h-12 tw-flex tw-rounded-xl tw-border-0 tw-m-0 tw-font-body tw-text-300 tw-text-gray-800 tw-bg-transparent tw-tracking-[49px] tw-pl-[18px] placeholder:tw-tracking-[49px]"
              #otpInput=""
              id="otpInput"
              data-testid="otp-input"
              [(ngModel)]="verificationCode"
              autocomplete="off"
              type="text"
              inputmode="numeric"
              pattern="[0-9]*"
              maxlength="4"
              autofocus="autofocus"
              (click)="onOtpClick($event)"
              (keydown)="commonUtilityHelper.acceptOnlyNumbers($event, 4)"
              (input)="onOtpChange()"
              (focus)="onInputFocus()"
              placeholder="xxxx"
              [ngClass]="{ 'tw-caret-transparent': otpInput?.value.toString().length === 4 }" />
          </div>
        </div>
      }
      @if (loginWithShiprocket) {
        <div class="tw-mb-8 tw-font-body tw-text-300 tw-text-gray-800 tw-transition-opacity tw-duration-200"
          [class.tw-opacity-40]="switchingToCureskinOtp"
          [class.tw-pointer-events-none]="switchingToCureskinOtp">
          <div class="tw-mb-1"
          i18n="@@facingIssues">Facing Issues?</div>
          @if (ui.timeLefForOTPCall > 0) {
            <span i18n="@@resendOtpIn">Resend OTP in {{ui.timeLefForOTPCall}}s</span>
          } @else {
            <span id="resendOtp"
              class="tw-text-teal-600 tw-font-bold"
              (click)="resendOtp()"
            i18n="@@resendOtp">Resend OTP</span>
          }
        </div>
      } @else if (ui.timeLefForOTPCall > 0) {
        <div class="tw-mb-8 tw-font-body tw-text-300 tw-text-gray-800"
          i18n="@@waitForCall"> Wait for a call in (<div class="dib text-center" style="width: 20px">{{ui.timeLefForOTPCall}}</div><span>) secs</span>
        </div>
      }
      <footer class="tw-h-[130px]">
        <button csButton
          id="continueBtn"
          data-testid="otp-continue"
          type="button"
          class="tw-w-full tw-mb-3 tw-relative proceed"
          [class]="{ 'tw-mt-[60px]': !(ui.timeLefForOTPCall > 0) }"
          [loading]="ui.loading"
          [disabled]="!isOtpValid"
          (click)="verifyOtp()"><span i18n="@@proceed">Proceed</span>
        </button>
        @if (loginWithShiprocket) {
          <div class="tw-font-body tw-text-100 tw-text-gray-500 tw-font-normal tw-text-center tw-tracking-[0.5px]"
            i18n="@@byContinuingAgreeShiprocket">By continuing, you agree to Cure's <span id="cure-terms" class="tw-text-gray-500 tw-font-bold" (click)='navigateTo("/iframe?src=https://cdn.cureskin.com/termsofservice_new.html&title=Terms%20of%20Use")'>T&amp;Cs</span>, <span id="cure-privacy" class="tw-text-gray-500 tw-font-bold" (click)='navigateTo("/iframe?src=https://cdn.cureskin.com/privacypolicy_new.html&title=Privacy%20Policy")'>Privacy Policy</span> and Shiprocket's <span id="shiprocket-terms" class="tw-text-gray-500 tw-font-bold" (click)='openExternalUrl("https://checkout.shiprocket.in/terms-conditions/")'>T&amp;Cs</span>, <span id="shiprocket-privacy" class="tw-text-gray-500 tw-font-bold" (click)='openExternalUrl("https://www.shiprocket.in/privacy-policy/my-shiprocket/")'>Privacy Policy</span></div>
          } @else {
            <div class="tw-font-body tw-text-100 tw-text-gray-500 tw-font-normal tw-text-center tw-tracking-[0.5px]"
              i18n="@@byContinuingAgree">
          <span>By continuing, you agree to</span>
          <span id="privacy-policy"
                class="tw-text-gray-500 tw-font-bold tw-mx-0.5"
                (click)='navigateTo("/iframe?src=https://cdn.cureskin.com/privacypolicy_new.html&title=Privacy%20Policy")'>Cure's Privacy Policy</span>
          <span>&</span>
          <span id="terms-of-service"
                class="tw-text-gray-500 tw-font-bold tw-ml-0.5"
                (click)='navigateTo("/iframe?src=https://cdn.cureskin.com/termsofservice_new.html&title=Terms%20of%20Use")'>Terms.</span>
        </div>
          }
        </footer>
      </div>
    </div>
